<template>
  <div>
       <register/>
  </div>
</template>
<script>
import register from '../components/register.vue'

export default {
   name:"registerPage",
   components:{
     register
   }
}
</script>
